import { render, staticRenderFns } from "./Fattorini.vue?vue&type=template&id=10c331c8&"
import script from "./Fattorini.vue?vue&type=script&lang=ts&"
export * from "./Fattorini.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports